import React, { useState, useEffect, useCallback } from "react";
import classnames from "classnames";
import { Link, useParams, useLocation, useNavigate } from "react-router-dom";
import {
  AGENCY_LIST,
  GET_LICENSE_TEMPLATE,
  DELETE_USER,
  EMPLOYEE_LIST,
  GET_SINGLE_USER,
  DECRYPT_PASSWORD_URL,
} from "../../../constants/ApiPaths";
import { useSnackbar } from "notistack";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Button,
  Row,
  Col,
  Container,
  Table,
  Card,
  Badge,
  Tooltip,
} from "reactstrap";
import { authHeader } from "../../../functions/CoreFunctions";
import API from "../../../redux/actions/API";
import AgencyCustomerModal from "./AgencyCustomerModal.jsx";
import { CustomAlertMessage } from "../../../functions/CustomFunctions";
import Swal from "sweetalert2";
import AgencyImage from "../../../constants/Images/defaultAgency-1.png";
import ProfileAvatar from "../../../constants/Images/defaultAvatar-1.png";
import BackButtonSvg from "../../common/BackButtonSvg";
import { TEMPLATE_DETAILS } from "../../../constants/RoutePaths";
import { Info } from "../../common/Info";

function AgencyDetails(sample) {
  const [activeTab, setActiveTab] = useState("1");
  const [Details, setDetails] = useState([]);
  const { agencyId } = useParams();
  const [Empoyee, setEmpoyee] = useState([]);
  const [isDeleted, setisDeleted] = useState(false);
  const [Count, setCount] = useState(0);
  const [flag, setflag] = useState(false);
  const [Licence, setLicence] = useState([]);
  const [Loading, setLoading] = useState(false);
  const [Cutomer, setCutomer] = useState([]);
  const location = useLocation();
  const history = useNavigate();
  const [Emaildisable, setEmaildisable] = useState(false);
  const { state } = location;
  const { enqueueSnackbar } = useSnackbar();
  const [CustomerModal, setCustomerModal] = useState(false);
  const [id, setid] = useState("");
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [lookupMail, setLookupMail] = useState();

  const toggle = (id) => {
    setid(id);
    setTooltipOpen(!tooltipOpen);
  };
  const initialValues = {
    firstName: "",
    email: "",
    lastName: "",
    phoneNumber: "+1 ",
    roleId: 3,
    city: "",
    hyperlink: window.location.origin,
    stateId: null,
    address: "",
    gender: "",
    dateOfBirth: "",
    profileImage: "",
    zip: "",
    agencyId: agencyId,
  };
  const [formdata, setformData] = useState(initialValues);
  const CustomerModalToogle = () => {
    if (isDeleted) {
      return;
    }
    Clean();
    setEmaildisable(false);
    setformData(initialValues);
    setflag(true);
    setCustomerModal(!CustomerModal);
  };
  const tabtoggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
    if (tab === "2") {
      GetEmployee();
    }
    if (tab === "3") {
      GetCustomer();
    }
  };

 const GetAgencyDetails = useCallback(async () => {
   setLoading(true);
   const config = {
     method: "GET",
     url: AGENCY_LIST,
     headers: authHeader(),
     params: {
       agencyId: agencyId,
     },
   };
   try {
     const response = await API(config);
     const { status, data } = response.data;
     if (status === "Success") {
       setDetails(data);
       setisDeleted(data[0].isDeleted);
     }
   } catch (error) {
     console.error(error);
   } finally {
     setLoading(false);
   }
 }, [agencyId]);

 const GetLicense = useCallback(async () => {
   setLoading(true);
   const config = {
     method: "GET",
     url: GET_LICENSE_TEMPLATE,
     headers: authHeader(),
     params: {
       agencyId: agencyId,
     },
   };
   try {
     const response = await API(config);
     const { status, data } = response.data;
     if (status === "Success") {
       setLicence(data);
     }
   } catch (error) {
     console.error(error);
   } finally {
     setLoading(false);
   }
 }, [agencyId]);

 const GetEmployee = useCallback(async () => {
   setLoading(true);
   const config = {
     method: "GET",
     url: EMPLOYEE_LIST,
     headers: authHeader(),
     params: {
       agencyId: agencyId,
       roleId: "3, 4",
     },
   };
   try {
     const response = await API(config);
     const { status, data } = response.data;
     if (status === "Success") {
       setEmpoyee(data);
     }
   } catch (error) {
     console.error(error);
   } finally {
     setLoading(false);
   }
 }, [agencyId]);

 useEffect(() => {
   GetAgencyDetails();
   GetLicense();
   if (state) {
     setActiveTab("2");
   }
   GetEmployee();
 }, [GetAgencyDetails, GetLicense, GetEmployee, state, Count]);

  const DeleteEmployee = async (ID) => {
    if (isDeleted) {
      return;
    }
    const config = {
      method: "DELETE",
      url: DELETE_USER,
      headers: authHeader(),
      params: {
        userId: ID,
      },
    };
    try {
      const response = await API(config);
      const { status   } = response.data;
      if (status === "Success") {
        setCount(Count + 1);
        CustomAlertMessage(
          "Employee Deleted Sucessfully!",
          "success",
          enqueueSnackbar
        );
      }
    } catch (error) {
    } finally {
    }
  };
  function DeleteDeteils(e) {
    const ID = e.currentTarget.dataset.userid;
    Swal.fire({
      title: "Are you sure?",
      text: "Are You Want to Delete this Employee!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        DeleteEmployee(ID);
      }
    });
  }

  const Profile = (i) => {
    const prof = i.agencyLogo;
    if (prof === "") {
      return <img src={AgencyImage} alt=""/>;
    } else {
      return <img src={i.agencyLogo} alt=""/>;
    }
  };
  const EmployeeProfile = (i) => {
    const prof = i.profileImage;
    if (prof === "") {
      return <img src={ProfileAvatar} alt=""/>;
    } else {
      return <img src={i.profileImage} alt=""/>;
    }
  };

  const CustomerProfile = (i) => {
    const prof = i.profileImage;
    if (prof === "") {
      return <img src={ProfileAvatar} alt=""/>;
    } else {
      return <img src={i.profileImage} alt=""/>;
    }
  };

  const GetCustomer = async () => {
    Clean();
    setLoading(true);
    const config = {
      method: "GET",
      url: EMPLOYEE_LIST,
      headers: authHeader(),
      params: {
        agencyId: agencyId,
        roleId: 5,
      },
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;
      if (status === "Success") {
        setCutomer(data);
        setLoading(false);
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  };

  const getDecrypted = async (password) => {
    const config = {
      method: "POST",
      headers: authHeader(),
      url: DECRYPT_PASSWORD_URL,
      data: {
        encrypt: password,
      },
    };
    try {
      const response = await API(config);
      if (response) {
        return response.data;
      }
    } catch (error) {
      console.error(error);
    }
  };

  const UpdateUser = async (e) => {
    if (isDeleted) {
      return;
    }
    setEmaildisable(true);
    Clean();
    setCustomerModal(!CustomerModal);
    setLoading(true);
    setflag(false);
    const ID = e.currentTarget.dataset.userid;
    const config = {
      method: "GET",
      url: GET_SINGLE_USER,
      headers: authHeader(),
      params: {
        userId: ID,
      },
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;
      if (status === "Success") {
        if (data.password) {
          data.password = await getDecrypted(data.password);
        }
        setformData({ ...data, phoneNumber: "+1 ".concat(data.phoneNumber) });
        setLoading(false);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const TemplateStatus = (i) => {
    const status = i.templateStatus;
    if (status === "Pending") {
      return (
        <Badge color="warning" className="mr-3 badge-warning-soft">
          In Progress
        </Badge>
      );
    } else if (status === "Approved") {
      return (
        <Badge color="success" className="mr-3 badge-success-soft">
          Approved
        </Badge>
      );
    }
  };

  const Clean = () => [
    setformData({
      firstName: "",
      email: "",
      lastName: "",
      phoneNumber: "+1 ",
      roleId: 4,
      city: "",
      hyperlink: window.location.origin,
      stateId: "",
      address: "",
      gender: "",
      dateOfBirth: "",
      profileImage: "",
      zip: "",
      agencyId: agencyId,
    }),
  ];
  return (
    <div>
      <div className="wrapper">
        {Loading && <CustomPageLoading />}
        <Container fluid>
          <div className="page-title">
            <h4>
              Agency Details
              <Tooltip
                isOpen={id === "agencydetails" && tooltipOpen}
                target={"agencydetails"}
                toggle={() => toggle("agencydetails")}
              >
                Agency Details
              </Tooltip>
              <span id={"agencydetails"}>
                <Info />
              </span>
            </h4>
            <div className="top-btn">
              <Button
                color="primary"
                onClick={() => {
                  history(-1);
                }}
              >
                <BackButtonSvg />
                Back
              </Button>
            </div>
          </div>

          <Card body className="mt-4">
            {Details.map((i) => (
              <>
                <div className="agency-info">
                  <Row>
                    <Col>
                      <div className="profile-info">
                        {Profile(i)}
                        <div className="link">
                          <Badge color="primary">Customer Portal URL :</Badge>
                          <a
                            href={
                              `${window.location.origin}` +
                              "/customer/" +
                              `${i.agencyUrl}`
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {" "}
                            {window.location.origin}/customer/{i.agencyUrl}
                          </a>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>

                <Row className="details">
                  <Col lg="6">
                    <div className="detailsbox">
                      <h5>Personal Info</h5>
                      <div className="box-body">
                        <Row>
                          <Col lg="6">
                            <div className="info">
                              <span>Email</span>
                              <p>{i.agencyEmail}</p>
                            </div>

                            <div className="info">
                              <span>Address</span>
                              <p>{i.address}</p>
                            </div>

                            <div className="info">
                              <span>State</span>
                              <p>{i.stateName}</p>
                            </div>
                          </Col>
                          <Col lg="6">
                            <div className="info">
                              <span>Phone Number</span>
                              <p>{`+1 ${i.phoneNumber}`}</p>
                            </div>
                            <div className="info">
                              <span>City</span>
                              <p>{i.city}</p>
                            </div>
                            <div className="info">
                              <span>Zip</span>
                              <p>{i.zip}</p>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                  <Col lg="6">
                    <div className="detailsbox">
                      <h5>Bank Details</h5>
                      <div className="box-body">
                        <Row>
                          <Col lg="6">
                            <div className="info">
                              <span>Account Number</span>
                              <p>{i.accountNumber}</p>
                            </div>

                            <div className="info">
                              <span>Routing Number</span>
                              <p>{i.routingNumber}</p>
                            </div>
                          </Col>
                          <Col lg="6">
                            <div className="info">
                              <span>Holder Name</span>
                              <p>{i.accountHolderName}</p>
                            </div>
                            <div className="info">
                              <span>Bank Address</span>
                              <p>{i.bankAddress}</p>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col sm="12">
                    <Row className="agency-status">
                      <Col md="6" lg="4" xl="3">
                        <div className="box">
                          <div className="icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="38.308"
                              height="39.532"
                              viewBox="0 0 38.308 39.532"
                            >
                              <g
                                id="page-design-template-with-three-areas"
                                transform="translate(-0.434)"
                              >
                                <path
                                  id="Path_29"
                                  data-name="Path 29"
                                  d="M35.55,0H3.626A3.171,3.171,0,0,0,.434,3.148V36.386a3.172,3.172,0,0,0,3.192,3.146H35.55a3.172,3.172,0,0,0,3.192-3.146V3.148A3.171,3.171,0,0,0,35.55,0ZM5.537,2.368h28.1a2.787,2.787,0,0,1,2.813,2.769v5.426H2.726V5.137A2.791,2.791,0,0,1,5.537,2.368ZM2.726,34.4V13.628H23.551V37.165H5.537A2.794,2.794,0,0,1,2.726,34.4Zm30.911,2.769H26.728V13.628h9.722V34.4A2.791,2.791,0,0,1,33.636,37.165Z"
                                  transform="translate(0)"
                                  fill="#fff"
                                />
                              </g>
                            </svg>
                          </div>
                          <div className="count">
                            <span>
                              License
                              <Tooltip
                                isOpen={id === "license" && tooltipOpen}
                                target={"license"}
                                toggle={() => toggle("license")}
                              >
                                Total number of licenses
                              </Tooltip>
                              <span id={"license"}>
                                <Info />
                              </span>
                            </span>
                            <p>{i.totalLicense}</p>
                          </div>
                        </div>
                      </Col>
                      <Col md="6" lg="4" xl="3">
                        <div className="box">
                          <div className="icon">
                            <svg
                              id="suitcase"
                              xmlns="http://www.w3.org/2000/svg"
                              width="48.76"
                              height="37.344"
                              viewBox="0 0 48.76 37.344"
                            >
                              <g id="Group_23" data-name="Group 23">
                                <path
                                  id="Path_9"
                                  data-name="Path 9"
                                  d="M44.474,66H31.11V64.221a4.29,4.29,0,0,0-4.286-4.286H21.936a4.29,4.29,0,0,0-4.286,4.286V66H4.286A4.29,4.29,0,0,0,0,70.281V92.994a4.29,4.29,0,0,0,4.286,4.286H44.474a4.29,4.29,0,0,0,4.286-4.286V70.281A4.29,4.29,0,0,0,44.474,66Zm-22.539-3.2h4.888a1.43,1.43,0,0,1,1.429,1.429V66H20.507V64.221h0A1.43,1.43,0,0,1,21.936,62.792ZM8.379,94.422H4.286a1.43,1.43,0,0,1-1.429-1.429V70.281a1.43,1.43,0,0,1,1.429-1.428H8.379v25.57Zm29.146,0H11.236V68.852H37.524ZM45.9,92.994a1.43,1.43,0,0,1-1.429,1.429H40.381V68.852h4.093A1.43,1.43,0,0,1,45.9,70.281Z"
                                  transform="translate(0 -59.935)"
                                  fill="#fff"
                                />
                              </g>
                            </svg>
                          </div>
                          <div className="count">
                            <span>
                              Employee
                              <Tooltip
                                isOpen={id === "employee" && tooltipOpen}
                                target={"employee"}
                                toggle={() => toggle("employee")}
                              >
                                Total count of employees
                              </Tooltip>
                              <span id={"employee"}>
                                <Info />
                              </span>
                            </span>
                            <p>{i.totalEmployee}</p>
                          </div>
                        </div>
                      </Col>
                      <Col md="6" lg="4" xl="3">
                        <div className="box">
                          <div className="icon">
                            <svg
                              id="user_1_"
                              data-name="user (1)"
                              xmlns="http://www.w3.org/2000/svg"
                              width="53.721"
                              height="35.035"
                              viewBox="0 0 53.721 35.035"
                            >
                              <g
                                id="Group_11"
                                data-name="Group 11"
                                transform="translate(18.685)"
                              >
                                <g id="Group_10" data-name="Group 10">
                                  <path
                                    id="Path_3"
                                    data-name="Path 3"
                                    d="M178.841,85.333a8.175,8.175,0,1,0,8.175,8.175A8.184,8.184,0,0,0,178.841,85.333Zm0,14.014a5.839,5.839,0,1,1,5.839-5.839A5.847,5.847,0,0,1,178.841,99.347Z"
                                    transform="translate(-170.666 -85.333)"
                                    fill="#fff"
                                  />
                                </g>
                              </g>
                              <g
                                id="Group_13"
                                data-name="Group 13"
                                transform="translate(37.371 9.343)"
                              >
                                <g
                                  id="Group_12"
                                  data-name="Group 12"
                                  transform="translate(0 0)"
                                >
                                  <path
                                    id="Path_4"
                                    data-name="Path 4"
                                    d="M347.173,170.667a5.839,5.839,0,1,0,5.839,5.839A5.847,5.847,0,0,0,347.173,170.667Zm0,9.343a3.5,3.5,0,1,1,3.5-3.5A3.508,3.508,0,0,1,347.173,180.01Z"
                                    transform="translate(-341.334 -170.667)"
                                    fill="#fff"
                                  />
                                </g>
                              </g>
                              <g
                                id="Group_15"
                                data-name="Group 15"
                                transform="translate(4.837 9.343)"
                              >
                                <g
                                  id="Group_14"
                                  data-name="Group 14"
                                  transform="translate(0 0)"
                                >
                                  <path
                                    id="Path_5"
                                    data-name="Path 5"
                                    d="M50.021,170.667a5.839,5.839,0,1,0,5.839,5.839A5.846,5.846,0,0,0,50.021,170.667Zm0,9.343a3.5,3.5,0,1,1,3.5-3.5A3.508,3.508,0,0,1,50.021,180.01Z"
                                    transform="translate(-44.182 -170.667)"
                                    fill="#fff"
                                  />
                                </g>
                              </g>
                              <g
                                id="Group_17"
                                data-name="Group 17"
                                transform="translate(11.678 18.685)"
                              >
                                <g id="Group_16" data-name="Group 16">
                                  <path
                                    id="Path_6"
                                    data-name="Path 6"
                                    d="M121.848,256a15.2,15.2,0,0,0-15.182,15.182,1.168,1.168,0,0,0,2.336,0,12.846,12.846,0,1,1,25.692,0,1.168,1.168,0,0,0,2.336,0A15.2,15.2,0,0,0,121.848,256Z"
                                    transform="translate(-106.666 -256)"
                                    fill="#fff"
                                  />
                                </g>
                              </g>
                              <g
                                id="Group_19"
                                data-name="Group 19"
                                transform="translate(37.204 23.357)"
                              >
                                <g id="Group_18" data-name="Group 18">
                                  <path
                                    id="Path_7"
                                    data-name="Path 7"
                                    d="M345.819,298.667a10.51,10.51,0,0,0-5.444,1.518,1.168,1.168,0,1,0,1.212,2,8.176,8.176,0,0,1,12.407,7,1.168,1.168,0,1,0,2.336,0A10.524,10.524,0,0,0,345.819,298.667Z"
                                    transform="translate(-339.813 -298.667)"
                                    fill="#fff"
                                  />
                                </g>
                              </g>
                              <g
                                id="Group_21"
                                data-name="Group 21"
                                transform="translate(0 23.357)"
                              >
                                <g id="Group_20" data-name="Group 20">
                                  <path
                                    id="Path_8"
                                    data-name="Path 8"
                                    d="M15.953,300.183A10.514,10.514,0,0,0,0,309.178a1.168,1.168,0,1,0,2.336,0,8.178,8.178,0,0,1,12.4-7,1.168,1.168,0,0,0,1.212-2Z"
                                    transform="translate(0 -298.667)"
                                    fill="#fff"
                                  />
                                </g>
                              </g>
                            </svg>
                          </div>
                          <div className="count">
                            <span>
                              Customer
                              <Tooltip
                                isOpen={id === "customer" && tooltipOpen}
                                target={"customer"}
                                toggle={() => toggle("customer")}
                              >
                                Total count of customers
                              </Tooltip>
                              <span id={"customer"}>
                                <Info />
                              </span>
                            </span>
                            <p>{i.totalCustomer}</p>
                          </div>
                        </div>
                      </Col>
                      <Col md="6" lg="4" xl="3">
                        <div className="box">
                          <div className="icon">
                            <svg
                              id="user_1_"
                              data-name="user (1)"
                              xmlns="http://www.w3.org/2000/svg"
                              width="53.721"
                              height="35.035"
                              viewBox="0 0 53.721 35.035"
                            >
                              <g
                                id="Group_11"
                                data-name="Group 11"
                                transform="translate(18.685)"
                              >
                                <g id="Group_10" data-name="Group 10">
                                  <path
                                    id="Path_3"
                                    data-name="Path 3"
                                    d="M178.841,85.333a8.175,8.175,0,1,0,8.175,8.175A8.184,8.184,0,0,0,178.841,85.333Zm0,14.014a5.839,5.839,0,1,1,5.839-5.839A5.847,5.847,0,0,1,178.841,99.347Z"
                                    transform="translate(-170.666 -85.333)"
                                    fill="#fff"
                                  />
                                </g>
                              </g>
                              <g
                                id="Group_13"
                                data-name="Group 13"
                                transform="translate(37.371 9.343)"
                              >
                                <g
                                  id="Group_12"
                                  data-name="Group 12"
                                  transform="translate(0 0)"
                                >
                                  <path
                                    id="Path_4"
                                    data-name="Path 4"
                                    d="M347.173,170.667a5.839,5.839,0,1,0,5.839,5.839A5.847,5.847,0,0,0,347.173,170.667Zm0,9.343a3.5,3.5,0,1,1,3.5-3.5A3.508,3.508,0,0,1,347.173,180.01Z"
                                    transform="translate(-341.334 -170.667)"
                                    fill="#fff"
                                  />
                                </g>
                              </g>
                              <g
                                id="Group_15"
                                data-name="Group 15"
                                transform="translate(4.837 9.343)"
                              >
                                <g
                                  id="Group_14"
                                  data-name="Group 14"
                                  transform="translate(0 0)"
                                >
                                  <path
                                    id="Path_5"
                                    data-name="Path 5"
                                    d="M50.021,170.667a5.839,5.839,0,1,0,5.839,5.839A5.846,5.846,0,0,0,50.021,170.667Zm0,9.343a3.5,3.5,0,1,1,3.5-3.5A3.508,3.508,0,0,1,50.021,180.01Z"
                                    transform="translate(-44.182 -170.667)"
                                    fill="#fff"
                                  />
                                </g>
                              </g>
                              <g
                                id="Group_17"
                                data-name="Group 17"
                                transform="translate(11.678 18.685)"
                              >
                                <g id="Group_16" data-name="Group 16">
                                  <path
                                    id="Path_6"
                                    data-name="Path 6"
                                    d="M121.848,256a15.2,15.2,0,0,0-15.182,15.182,1.168,1.168,0,0,0,2.336,0,12.846,12.846,0,1,1,25.692,0,1.168,1.168,0,0,0,2.336,0A15.2,15.2,0,0,0,121.848,256Z"
                                    transform="translate(-106.666 -256)"
                                    fill="#fff"
                                  />
                                </g>
                              </g>
                              <g
                                id="Group_19"
                                data-name="Group 19"
                                transform="translate(37.204 23.357)"
                              >
                                <g id="Group_18" data-name="Group 18">
                                  <path
                                    id="Path_7"
                                    data-name="Path 7"
                                    d="M345.819,298.667a10.51,10.51,0,0,0-5.444,1.518,1.168,1.168,0,1,0,1.212,2,8.176,8.176,0,0,1,12.407,7,1.168,1.168,0,1,0,2.336,0A10.524,10.524,0,0,0,345.819,298.667Z"
                                    transform="translate(-339.813 -298.667)"
                                    fill="#fff"
                                  />
                                </g>
                              </g>
                              <g
                                id="Group_21"
                                data-name="Group 21"
                                transform="translate(0 23.357)"
                              >
                                <g id="Group_20" data-name="Group 20">
                                  <path
                                    id="Path_8"
                                    data-name="Path 8"
                                    d="M15.953,300.183A10.514,10.514,0,0,0,0,309.178a1.168,1.168,0,1,0,2.336,0,8.178,8.178,0,0,1,12.4-7,1.168,1.168,0,0,0,1.212-2Z"
                                    transform="translate(0 -298.667)"
                                    fill="#fff"
                                  />
                                </g>
                              </g>
                            </svg>
                          </div>
                          <div className="count">
                            <span>
                              Agency Admin
                              <Tooltip
                                isOpen={id === "agencyadmin" && tooltipOpen}
                                target={"agencyadmin"}
                                toggle={() => toggle("agencyadmin")}
                              >
                                Total of agency administrators
                              </Tooltip>
                              <span id={"agencyadmin"}>
                                <Info />
                              </span>
                            </span>
                            <p>{i.totalAgencyAdmin}</p>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </>
            ))}

            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "1" })}
                  onClick={() => {
                    tabtoggle("1");
                  }}
                >
                  License
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "2" })}
                  onClick={() => {
                    tabtoggle("2");
                  }}
                >
                  Agency Admin
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "3" })}
                  onClick={() => {
                    tabtoggle("3");
                  }}
                >
                  Customer
                </NavLink>
              </NavItem>
            </Nav>

            <TabContent activeTab={activeTab}>
              <TabPane tabId="1">
                {Loading ? (
                  ""
                ) : Licence.length === 0 ? (
                  <center>No Record Found</center>
                ) : (
                  <>
                    {Licence.map((i) => (
                      <div className="license-card">
                        <Row>
                          <Col>
                            <h4>{i.licenseName}</h4>
                          </Col>
                        </Row>
                        <Row>
                          <Col xl="4">
                            <div className="info">
                              <a
                                href={
                                  `${window.location.origin}` +
                                  "/customer/" +
                                  `${i.agencyUrl}`
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {i.agencyUrl}
                              </a>
                              <span>Template url</span>
                            </div>
                          </Col>
                          <Col sm="6" xl="2">
                            <div className="info">
                              <p>{i.createdDate}</p>
                              <span>CREATED DATE</span>
                            </div>
                          </Col>
                          <Col sm="6" xl="2">
                            <div className="info">
                              <p>{i.licensePlanCount}</p>
                              <span>No of Plan</span>
                            </div>
                          </Col>
                          <Col sm="6" xl="2">
                            <div className="info">
                              <p>{i.totalUser}</p>
                              <span>Total Users</span>
                            </div>
                          </Col>
                          <Col>{TemplateStatus(i)}</Col>
                          <Col className="status-section">
                              <Link
                                to={`/admin/templatedetails/${i.templateId}`}
                              >
                                <Button color="primary" size="sm">
                                  View
                                </Button>
                            </Link>
                          </Col>
                        </Row>{" "}
                      </div>
                    ))}
                  </>
                )}
              </TabPane>

              <TabPane tabId="2">
                <div className="mt-4">
                  <div className="mb-4">
                    <Button
                      disabled={isDeleted}
                      onClick={CustomerModalToogle}
                      color="primary"
                      className="ml-auto d-block"
                    >
                      <svg
                        className="mr-3"
                        xmlns="http://www.w3.org/2000/svg"
                        width="12.401"
                        height="12.402"
                        viewBox="0 0 12.401 12.402"
                      >
                        <g
                          id="Icon_feather-plus"
                          data-name="Icon feather-plus"
                          transform="translate(-6.6 -6.6)"
                        >
                          <path
                            id="Path_82"
                            data-name="Path 82"
                            d="M18,7.5V18.1"
                            transform="translate(-5.199)"
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.8"
                          />
                          <path
                            id="Path_83"
                            data-name="Path 83"
                            d="M7.5,18H18.1"
                            transform="translate(0 -5.199)"
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.8"
                          />
                        </g>
                      </svg>
                      New Agency Admin
                    </Button>
                  </div>

                  {Loading ? (
                    ""
                  ) : Empoyee.length === 0 ? (
                    <>
                      <center>No Record Found</center>
                    </>
                  ) : (
                    <>
                      <Row>
                        {Empoyee.map((i) => (
                          <Col md="6" lg="6" xl="4">
                            <div className="employee-box">
                              {EmployeeProfile(i)}
                              <h5>
                                {i.firstName} {i.lastName}
                              </h5>
                              <Badge color="primary">Admin</Badge>
                              <div className="action-btn">
                                <Button
                                  disabled={isDeleted}
                                  className="editBtn"
                                  data-userid={i.userId}
                                  onClick={UpdateUser}
                                  color="link"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="10.928"
                                    height="10.928"
                                    viewBox="0 0 10.928 10.928"
                                  >
                                    <path
                                      id="Icon_material-mode-edit"
                                      data-name="Icon material-mode-edit"
                                      d="M4.5,13.148v2.276H6.776L13.49,8.711,11.214,6.434Zm10.75-6.2a.6.6,0,0,0,0-.856l-1.42-1.42a.6.6,0,0,0-.856,0L11.863,5.785,14.14,8.061,15.25,6.95Z"
                                      transform="translate(-4.5 -4.496)"
                                      fill="#fff"
                                    />
                                  </svg>
                                </Button>
                                <Button
                                  disabled={isDeleted}
                                  onClick={DeleteDeteils}
                                  data-userid={i.userId}
                                  className="deleteBtn"
                                  color="link"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="10.236"
                                    height="13.161"
                                    viewBox="0 0 10.236 13.161"
                                  >
                                    <path
                                      id="Icon_material-delete"
                                      data-name="Icon material-delete"
                                      d="M8.231,16.2a1.467,1.467,0,0,0,1.462,1.462h5.849A1.467,1.467,0,0,0,17.005,16.2V7.425H8.231ZM17.736,5.231H15.177L14.446,4.5H10.79l-.731.731H7.5V6.693H17.736Z"
                                      transform="translate(-7.5 -4.5)"
                                      fill="#fff"
                                    />
                                  </svg>
                                </Button>
                              </div>

                              <div className="list-group list-group-flush list-group-no-gutters mt-4">
                                <div className="list-group-item">
                                  <div className="row align-items-center">
                                    <div className="col">
                                      <small className="card-subtitle">
                                        Full Name :
                                      </small>
                                    </div>

                                    <div className="col-auto">
                                      <p>
                                        {i.firstName}
                                        {i.lastName}
                                      </p>
                                    </div>
                                  </div>
                                </div>

                                <div className="list-group-item">
                                  <div className="row align-items-center">
                                    <div className="col">
                                      <small className="card-subtitle">
                                        Mobile :
                                      </small>
                                    </div>

                                    <div className="col-auto">
                                      <p>{`+1 ${i.phoneNumber}`}</p>
                                    </div>
                                  </div>
                                </div>

                                <div className="list-group-item">
                                  <div className="row align-items-center">
                                    <div className="col">
                                      <small className="card-subtitle">
                                        Email :
                                      </small>
                                    </div>

                                    <div className="col-auto">
                                      <p>{i.email}</p>
                                    </div>
                                  </div>
                                </div>

                                <div className="list-group-item">
                                  <div className="row align-items-center">
                                    <div className="col">
                                      <small className="card-subtitle">
                                        Location :
                                      </small>
                                    </div>

                                    <div className="col-auto">
                                      <p>{i.stateName}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Col>
                        ))}
                      </Row>
                    </>
                  )}
                </div>
              </TabPane>

              <TabPane tabId="3">
                <Row>
                  <Col sm="12">
                    <Card body className="mt-4">
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>Logo</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone number</th>
                          </tr>
                        </thead>
                        {Loading ? (
                          ""
                        ) : Cutomer.length === 0 ? (
                          <tbody>
                            <tr>
                              <td colSpan={9}>
                                <center>No Record Found</center>
                              </td>
                            </tr>
                          </tbody>
                        ) : (
                          <tbody>
                            {Cutomer.map((i) => (
                              <tr key={i.userId}>
                                <td>{CustomerProfile(i)}</td>
                                <td>
                                  {i.firstName} {i.lastName}
                                </td>
                                <td>{i.email}</td>
                                <td>{`+1 ${i.phoneNumber}`}</td>
                              </tr>
                            ))}
                          </tbody>
                        )}
                      </Table>
                    </Card>
                  </Col>
                </Row>
              </TabPane>
            </TabContent>
          </Card>
        </Container>
        <AgencyCustomerModal
          Emaildisable={Emaildisable}
          Clean={Clean}
          flag={flag}
          setflag={setflag}
          setformData={setformData}
          CustomerModal={CustomerModal}
          setCount={setCount}
          formdata={formdata}
          Count={Count}
          lookupMail={lookupMail}
          agencyId={agencyId}
          CustomerModalToogle={CustomerModalToogle}
          setLookupMail={setLookupMail}
        />
      </div>
    </div>
  );
}

export default AgencyDetails;
